// extracted by mini-css-extract-plugin
module.exports = {"box":"Box_box__MF_QO","icon":"Box_icon__N0ASh"};